import {
  UPDATE_PHONE_NUMBER_ERROR,
  UPDATE_PHONE_NUMBER_SUCCESS,
} from '../actions';

const initialState = {
  phone: '',
  error: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_PHONE_NUMBER_SUCCESS: {
      return {
        ...state,
        error: false,
        phone: action.payload.phone,
      };
    }
    case UPDATE_PHONE_NUMBER_ERROR: {
      return {
        ...state,
        phone: initialState.phone,
        error: action.error,
      };
    }
    default:
      return state;
  }
}
